import { Display } from "../../../Models/Display";

export const getParcelsHeaderGridLayout = () => ({
  columns: "2fr 1fr 1fr 1fr 1fr 1fr",
  areas: ` 
      "internalReference width length height weight volume "
    `,
});

export const getParcelsListGridLayout = (display: Display) => ({
  columns: display.xs
    ? "1fr"
    : display.sm
      ? "1fr 1fr"
      : display.md
        ? "1fr 1fr 1fr"
        : "2fr 1fr 1fr 1fr 1fr 1fr",

  areas: display.xs
    ? `
      "internalReference"
      "width"
      "length"
      "height"
      "weight"
      "volume"
    `
    : display.sm
      ? `
      "internalReference internalReference"
      "width length"
      "height weight"
      "volume volume"
    `
      : display.md
        ? `
      "internalReference weight volume"
      "width length height"
    `
        : `
      "internalReference width length height weight volume"
    `,
});

export const getParcelsFooterGridLayout = (display: Display) => ({
  columns: display.xs
    ? "1fr"
    : display.sm
      ? "1fr 1fr"
      : display.md
        ? "1fr 1fr 1fr"
        : "2fr 1fr 1fr 1fr 1fr 1fr",

  areas: display.xs
    ? `
      "totalQuantity"
      "totalWeight"
      "totalVolume"
    `
    : display.sm
      ? `
      "totalQuantity totalQuantity"
      "totalWeight totalVolume"
    `
      : display.md
        ? `
      "totalQuantity totalWeight totalVolume"
    `
        : `
      ". . . totalQuantity totalWeight totalVolume"
    `,
});
